import actions from './actions';
import getters from './getters';
import mutations from './mutations';

function state() {
  return {
    faqs: [],
    faq: false,
    loading: false,
    formLoading: false,
    error: false,
    success: false,
  };
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/FAQs/index.js